module.exports = __webpack_public_path__ + "static/media/adverse-events.2bbbe9e5.png";